import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMug = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		d: "M6.71569 3.14038V0.999928M3.65686 3.14038V0.999928M9.77451 3.14038V0.999928M3.52941 15H10.4118C11.2564 15 11.9412 14.3611 11.9412 13.573V5.7247C11.9412 5.33065 11.5988 5.01122 11.1765 5.01122H2.76471C2.34237 5.01122 2 5.33065 2 5.7247V13.573C2 14.3611 2.68474 15 3.52941 15ZM11.9412 6.43819H12.7059C13.9729 6.43819 15 7.3965 15 8.57864C15 9.76078 13.9729 10.7191 12.7059 10.7191H11.9412V6.43819Z"
	})
});
export default SvgMug;
